import { render, staticRenderFns } from "./personnel.vue?vue&type=template&id=5346961b&scoped=true&"
import script from "./personnel.vue?vue&type=script&lang=js&"
export * from "./personnel.vue?vue&type=script&lang=js&"
import style0 from "./personnel.vue?vue&type=style&index=0&id=5346961b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5346961b",
  null
  
)

export default component.exports